import React, { useState, useCallback, ChangeEvent, memo } from 'react';
import { ReactComponent as SortIcon } from 'Icons/sortIcon.svg';
import './styles.scss';

interface Props {
  title: string;
  isTitleBold?: boolean;
  inputStyle?: React.CSSProperties;
  onInputChange?: (value: string) => void;
  onSortClick?: () => void;
  inputValue?: string;
  placeHolder?: string;
  showSearchInput?: boolean;
  titleStyle?: React.CSSProperties;
}

const SortingInput = (props: Props) => {
  const {
    title,
    isTitleBold = true,
    inputStyle,
    onInputChange,
    onSortClick,
    inputValue,
    placeHolder,
    showSearchInput = true,
    titleStyle = null,
  } = props;

  const [_inputValue, setInputValue] = useState<string>(inputValue || '');

  const handleInputChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>): void => {
      setInputValue(e.target.value);
      if (onInputChange) {
        onInputChange(e.target.value);
      }
    },
    [onInputChange],
  );

  return (
    <div
      id={`sortinginput-wrapper`}
      data-testid={`sortinginput-wrapper`}
      className="sort-input-root"
      onClick={onSortClick}
    >
      <div
        id={`sortinginput-container`}
        data-testid={`sortinginput-container`}
        className="flex items-center"
      >
        <div
          id={`sortinginput-${title}`}
          data-testid={`sortinginput-${title}`}
          className={`sort-input-title ${isTitleBold ? 'font-bold' : null}`}
          style={{ ...titleStyle }}
          title={title}
        >
          {title}
        </div>
        {onSortClick && (
          <div
            id={`sortinginput-sort-icon`}
            data-testid={`sortinginput-sort-icon`}
            className="pl-1"
          >
            <SortIcon />
          </div>
        )}
      </div>
      {showSearchInput && (
        <input
          id={`sortinginput-search-input`}
          data-testid={`sortinginput-search-input`}
          className="sort-input-search"
          type="text"
          value={_inputValue}
          style={{ ...inputStyle }}
          onChange={handleInputChange}
          placeholder={placeHolder}
          onClick={(e) => e.stopPropagation()}
        />
      )}
    </div>
  );
};

export default memo(SortingInput);
